export default __webpack_public_path__ + "static/media/sodexo-color.672f041a.svg";